import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionScope } from "@verbleif/lib/src/composables/Api/Type/UserPermissions/userPermission.enum";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export class GeneralLedgerVoter extends ContextVoter implements ContextVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationGeneralledgerCreateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationGeneralledgerCreate,
    });
  };

  public canRead: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationGeneralledgerReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationGeneralledgerRead,
      scope: PermissionScope.PROPERTY,
    });
  };

  public canDelete: ContextVoterInterface["canDelete"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationGeneralledgerDeleteany,
      contextAttribute: PermissionAttributesEnum.ContextOperationGeneralledgerDelete,
      scope: PermissionScope.PROPERTY,
    });
  };

  public canUpdate: ContextVoterInterface["canUpdate"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationGeneralledgerUpdateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationGeneralledgerUpdate,
      scope: PermissionScope.PROPERTY,
    });
  };

  public canManage: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationGeneralledgerCreateany,
        PermissionAttributesEnum.GlobalOperationGeneralledgerUpdateany,
        PermissionAttributesEnum.GlobalOperationGeneralledgerDeleteany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationGeneralledgerCreate,
        PermissionAttributesEnum.ContextOperationGeneralledgerUpdate,
        PermissionAttributesEnum.ContextOperationGeneralledgerDelete,
      ],
      scope: PermissionScope.PROPERTY,
    });
  };
}
